module.exports = __webpack_public_path__ + "ro.svg?c25fdab278341db26bb7da66543965ee";